import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { ProfileLink } from "@/components/ProfileDrawer";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export const Guards = () => {
  const [guards, setGuards] = useState([]);
  const [sites, setSites] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ full_name: "", phone: "+234 ", nin: "", rank: "Guard", skills: "", assigned_site_ids: [] });

  const load = useCallback(async () => {
    const r = await api.get("/guards");
    setGuards(r.data);
  }, []);

  useEffect(() => {
    load();
    api.get("/sites").then(r => setSites(r.data));
  }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/guards", {
        ...form,
        skills: form.skills.split(",").map(s => s.trim()).filter(Boolean),
      });
      toast.success("Guard added");
      setOpen(false);
      setForm({ full_name: "", phone: "+234 ", nin: "", rank: "Guard", skills: "", assigned_site_ids: [] });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div className="text-muted" style={{ fontSize: 14 }}>{guards.length} guards on file</div>
        <button className="btn-primary inline-flex items-center gap-2" onClick={() => setOpen(true)} data-testid="add-guard-btn">
          <Plus size={14} /> Add guard
        </button>
      </div>

      <div className="s-card" style={{ padding: 0, overflow: "hidden" }}>
        <table className="s-table">
          <thead>
            <tr><th>Name</th><th>Rank</th><th>Phone</th><th>NIN</th><th>Sites</th><th>Status</th></tr>
          </thead>
          <tbody>
            {guards.map(g => (
              <tr key={g.id} data-testid={`guard-row-${g.id}`}>
                <td style={{ color: "#fff" }}><ProfileLink kind="guard" id={g.id}>{g.full_name}</ProfileLink></td>
                <td className="text-muted">{g.rank}</td>
                <td className="mono">{g.phone}</td>
                <td className="mono text-muted">{g.nin}</td>
                <td>{(g.assigned_site_ids || []).length}</td>
                <td><StatusBadge status={g.active ? "ACTIVE" : "OFF"} label={g.active ? "Active" : "Inactive"} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div onClick={() => setOpen(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex",
          alignItems: "center", justifyContent: "center", zIndex: 100,
        }}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit}
                className="s-card" style={{ width: 420, maxWidth: "90vw" }}>
            <div className="flex justify-between items-center mb-4">
              <div className="h-section">Add guard</div>
              <button type="button" onClick={() => setOpen(false)} className="text-muted"><X size={18} /></button>
            </div>
            <label className="text-muted" style={{ fontSize: 12 }}>Full name</label>
            <input required value={form.full_name} onChange={(e) => setForm({...form, full_name: e.target.value})}
                   className="s-input mt-1 mb-3" data-testid="g-name" />
            <label className="text-muted" style={{ fontSize: 12 }}>Phone (+234)</label>
            <input required value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})}
                   className="s-input mt-1 mb-3" data-testid="g-phone" />
            <label className="text-muted" style={{ fontSize: 12 }}>NIN (11 digits)</label>
            <input required pattern="\d{11}" value={form.nin} onChange={(e) => setForm({...form, nin: e.target.value})}
                   className="s-input mt-1 mb-3 mono" data-testid="g-nin" />
            <label className="text-muted" style={{ fontSize: 12 }}>Rank</label>
            <input value={form.rank} onChange={(e) => setForm({...form, rank: e.target.value})}
                   className="s-input mt-1 mb-3" />
            <label className="text-muted" style={{ fontSize: 12 }}>Skills (comma separated)</label>
            <input value={form.skills} onChange={(e) => setForm({...form, skills: e.target.value})}
                   className="s-input mt-1 mb-3" placeholder="Armed Guard, CCTV Operator" />
            <label className="text-muted" style={{ fontSize: 12 }}>Assign to site</label>
            <select multiple value={form.assigned_site_ids}
                    onChange={(e) => setForm({...form, assigned_site_ids: Array.from(e.target.selectedOptions, o => o.value)})}
                    className="s-input mt-1 mb-4" style={{ height: 100 }}>
              {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
            <button type="submit" className="btn-primary w-full" data-testid="g-submit">Save guard</button>
          </form>
        </div>
      )}
    </div>
  );
};
